export default {"src":"/_next/static/media/icon-user-mobile.7b6f0f50.svg","height":40,"width":40};